function matchHeight() {
  if (window.innerWidth >= 750) {
    const target = document.querySelector('.why__answer--2 .why__answer__head');
    const reference = document.querySelector('.why__answer--1 .why__answer__head');
    if (target && reference) {
      target.style.height = 'auto'; // 一旦リセット
      target.style.height = `${reference.offsetHeight}px`;
    }
  } else {
    // 750px未満のときは高さをリセット（必要であれば）
    const target = document.querySelector('.why__answer--2 .why__answer__head');
    if (target) {
      target.style.height = 'auto';
    }
  }
}

window.addEventListener('load', matchHeight);
window.addEventListener('resize', matchHeight);
